import { render, staticRenderFns } from "./gmToolNewemailq.vue?vue&type=template&id=1c80ffad&scoped=true&"
import script from "./gmToolNewemailq.vue?vue&type=script&lang=js&"
export * from "./gmToolNewemailq.vue?vue&type=script&lang=js&"
import style0 from "./gmToolNewemailq.vue?vue&type=style&index=0&id=1c80ffad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c80ffad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c80ffad')) {
      api.createRecord('1c80ffad', component.options)
    } else {
      api.reload('1c80ffad', component.options)
    }
    module.hot.accept("./gmToolNewemailq.vue?vue&type=template&id=1c80ffad&scoped=true&", function () {
      api.rerender('1c80ffad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/email/gmToolNewemailq.vue"
export default component.exports